import { app } from '@/vendors/firebase/firebase';
import axios from 'axios';

const ls = require('local-storage');

export default {
  async loginWithMagicLinkToken(token) {
    return Promise.resolve(ls.set('shopToken', token));
  },

  async logout() {
    return Promise.resolve(ls.clear());
  },

  async getShopName(shopId) {
    const res = [];
    const snapshot = await app.firestore()
      .collection('shops')
      .where('id', '==', shopId)
      .get();
    snapshot.forEach((doc) => res.push(doc.data()));
    return res[0].name;
  },

  async getShopOrderCounter(shopId) {
    const res = [];
    const snapshot = await app.firestore()
      .collection('shops')
      .where('id', '==', shopId)
      .get();
    snapshot.forEach((doc) => res.push(doc.data()));
    return res[0].countOrder;
  },

  async getShopInfo(shopId) {
    const res = [];
    const snapshot = await app.firestore()
      .collection('shops')
      .where('id', '==', shopId)
      .get();
    snapshot.forEach((doc) => res.push(doc.data()));
    return res[0];
  },

  async getShopJWT(shopInfo) {
    console.log(shopInfo);
    const body = await axios.post(process.env.VUE_APP_GET_SHOP_JWT_ENDPOINT, {
      headers: {
        'Content-type': 'application/json',
      },
      params: {
        shopId: shopInfo.id.toString(),
        shopEmail: shopInfo.email,
      },
    });
    console.log('body: ', body);
    return body.data;
  },
};
